let directives = {
};

function install(Vue) {
  for (let k in directives) {
    Vue.directive(k, directives[k]);
  }
}

export default install;